import { axiosInstance } from '../../services'
import { ADD_CRM_EVENT, UPDATE_CRM } from '../../services/endpoints'
import { capitalizeText, getRoleString } from './helpers'
import { getInvestorDataFromSS } from './local-storage'
import { ClientJourneyEvent } from './client-journey-events'
import { enqueueAuditEvent } from './audit-event-queue'

/** @deprecated Use ClientJourneyEvent from client-journey-events.ts */
export enum EngagementEvents {
  USER_LOGGED_IN_EMAIL = 'userLoggedInEmail',
  USER_LOGGED_IN_SOCIAL = 'userLoggedInSocial',
  USER_SIGNED_UP_EMAIL = 'userSignedUpEmail',
  USER_SIGNED_UP_SOCIAL = 'userSignedUpSocial',
  VISITED_HOME_PAGE = 'visitedHomePage',
  VISITED_OPPORTUNITY = 'visitedOpportunity',
  VISITED_BLOG = 'visitedBlog',
  VISITED_NEWSLETTER = 'visitedNewsletter',
  ACCEPTED_CONFIDENTIALITY_AGREEMENT = 'acceptedConfidentialityAgreement',
  SELF_DECLARATION_SIGNED = 'selfDeclarationSigned',
  CLICKED_PROFILE_PAGE = 'clickedProfilePage',
  CLICKED_KYC_PAGE = 'clickedKycPage',
  VIEWED_OPPORTUNITY_DETAIL_PAGE = 'viewedOpportunityDetailPage',
  CLICKED_INVEST_BUTTON = 'clickedInvestButton',
  COMPLETED_FIRST_STEP_INVESTMENT = 'completedFirstStepInvestment',
  VIEWED_ACCEPTED_INVESTMENT_RISKS = 'viewedAcceptedInvestmentRisks',
  INVESTOR_VIEWED_TRANSACTION_CHECKLIST = 'investorViewedTransactionChecklist',
  INVESTOR_ACCEPTED_TRANSACTION_CHECKLIST = 'investorAcceptedTransactionChecklist',
  INVESTOR_ACCEPTED_TERMSHEET_AGREEMENT = 'investorAcceptedTermsheetAgreement',
  ACCEPT_TERMS_OF_BUSINESS = 'acceptTermsOfBusiness',
  CLIENT_AGREEMENT_SIGNED = 'clientAgreementSigned',
  PAYMENT_PROCESSED_SWIFT_COPY_UPLOADED = 'paymentProcessedSwiftCopyUploaded',
  VIEWED_ACCEPTED_DORMANCY_NOTIFICATION = 'viewedAcceptedDormancyNotification',
  VIEWED_ACCEPTED_DORMANCY_REMINDER = 'viewedAcceptedDormancyReminder',
  INVESTOR_FEEDBACK = 'investorFeedback',
}

export { ClientJourneyEvent }

export function logClientJourneyEvent(
  eventName: ClientJourneyEvent,
  eventData?: Record<string, unknown>,
): void {
  enqueueAuditEvent({
    eventName,
    metadata: eventData ?? {},
  })
}

export async function updateCrm(
  fieldName: string,
  fieldData: string,
  headers: { [key: string]: string },
): Promise<void> {
  try {
    await axiosInstance.post(
      UPDATE_CRM,
      {
        fieldName,
        fieldData,
      },
      {
        headers: headers,
      },
    )
  } catch (error: any) {
    return error.response
  }
}

export async function logCrmEvent(
  eventName: EngagementEvents,
  headers: { [key: string]: string },
  eventData?: Record<string, unknown>,
): Promise<any> {
  try {
    const { investorData } = getInvestorDataFromSS()
    let updatedEventName:
      | EngagementEvents
      | `admin${Capitalize<EngagementEvents>}`
      | `dev${Capitalize<EngagementEvents>}` = eventName
    let updatedEventData = { ...eventData }

    if (investorData.adminEmail && investorData.adminRole) {
      const role = getRoleString(investorData.adminRole)
      const capitalizedEventName = capitalizeText(updatedEventName)

      updatedEventName = `${role}${capitalizedEventName}` as
        | EngagementEvents
        | `admin${Capitalize<EngagementEvents>}`
        | `dev${Capitalize<EngagementEvents>}`

      updatedEventData = {
        ...updatedEventData,
        adminEmail: investorData.adminEmail,
        adminRole: investorData.adminRole,
      }
    }

    return await axiosInstance.post(
      ADD_CRM_EVENT,
      {
        eventName: updatedEventName,
        eventData: JSON.stringify(updatedEventData),
      },
      {
        headers: headers,
      },
    )
  } catch (error: any) {
    return error.response
  }
}
